import { useState } from 'react';
import _ from 'lodash';
import { FormProvider, useForm } from 'react-hook-form';
import { t, Trans } from '@lingui/macro';
import { Button } from '@material-ui/core';
import NgpTwoButtonDialog from '../../dialog-two-button/NgpTwoButtonDialog';
import { USE_FORM_DEFAULT_OPTIONS } from '../../../utilities/FormUtilities';
import { useStyles } from './SiteAdminStyles';
import { useDataService } from '../../../services/ApiDataService';
import { SITE_IMPORT_FILE_FIELD } from './SiteAdminConstants';
import ImportDialogForm from './ImportDialogForm';
import ImportDialogProgress from './ImportDialogProgress';

const importApiUrl = '/ipm/v1/sitesImport/importCSV';

export default function ImportDialog({ gridRefresherFunc }) {
    const classes = useStyles();
    const dataService = useDataService();
    const [showImportDialog, setShowImportDialog] = useState(false);
    const [initialImportState, setInitialImportState] = useState(null);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [key, setKey] = useState(_.uniqueId());
    const methods = useForm({
        ...USE_FORM_DEFAULT_OPTIONS,
    });
    const { handleSubmit, watch, reset } = methods;
    const importFile = watch(SITE_IMPORT_FILE_FIELD);

    const handleFormSubmit = (formData) => {
        const fileKey = 'file';
        const asFormData = new FormData();

        asFormData.append(fileKey, formData[SITE_IMPORT_FILE_FIELD]);
        setFormSubmitted(true);

        return dataService.postFormData(importApiUrl, asFormData).then((response) => {
            setInitialImportState(response);
            reset();
        });
    };

    const handleImportClick = () => {
        setShowImportDialog(true);
    };

    const handleOnClose = () => {
        setShowImportDialog(false);
        setKey(_.uniqueId());
        // So the dialog doesn't blink
        setTimeout(() => {
            reset({});
            setFormSubmitted(false);
            setInitialImportState({});
        }, 100);
    };

    return (
        <FormProvider {...methods} key={key}>
            <Button variant="contained" color="primary" onClick={handleImportClick}>
                <Trans>Import</Trans>
            </Button>
            <NgpTwoButtonDialog
                title={t`Import Sites File`}
                confirmButtonText={<Trans>Upload</Trans>}
                cancelButtonText={<Trans>Close</Trans>}
                open={showImportDialog}
                setOpen={setShowImportDialog}
                callerWillCloseOnConfirm
                onConfirm={handleSubmit(handleFormSubmit)}
                confirmButtonDisabled={!importFile}
                onCloseFunc={handleOnClose}
                disableBackdropClick
                showConfirmButton={!formSubmitted}
            >
                {!formSubmitted && <ImportDialogForm classes={classes} />}

                {formSubmitted && (
                    <ImportDialogProgress
                        initialImportState={initialImportState}
                        classes={classes}
                        gridRefresherFunc={gridRefresherFunc}
                        key={key}
                    />
                )}
            </NgpTwoButtonDialog>
        </FormProvider>
    );
}
